import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { LocalStorageService } from '@app/shared/services/local-storage/local-storage.service';
import { LoginService } from '@app/login/login.service';
import { HTTP_CODES } from '@app/shared/constants/httpCodes';
import { Observable } from 'rxjs';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(
    private readonly localStorageService: LocalStorageService,
    private readonly loginService: LoginService,
  ) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.localStorageService.getToken();
    let updatedRequest = request;
    if (token) {
      const authToken = token;
      updatedRequest = request.clone({
        setHeaders: {
          Authorization: `Bearer ${authToken}`,
        },
      });
    }

    return next.handle(updatedRequest).pipe(
      tap(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            return next.handle(updatedRequest);
          }
        },
        error => {
          if (error instanceof HttpErrorResponse) {
            if (
              error.status === HTTP_CODES.unauthorized && !request.url.includes('onboarding/config')
              && !request.url.includes('login')
              ) {
              this.loginService.signOut();
            }
          }
        },
      ),
    );
  }
}
